import React from 'react';
import Navbar from '../Components/Landingpage/Navbar';
import Footer from '../Components/Landingpage/Footer';
import BackToTop from '../Components/Landingpage/BackToTop';
import { getCompanyName, getEmail, getPhone, getPhoneLink, getLegalInfo } from '../data/companyDetails';

const Refund = () => {
  const companyName = getCompanyName();
  const email = getEmail();
  const phone = getPhone();
  const phoneLink = getPhoneLink();
  const legal = getLegalInfo();

  return (
    <>
      <Navbar />
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h1 className="display-4 mb-4 text-primary">Cancellation and Refund Policy</h1>
              <p className="text-muted mb-4">Last updated: {legal.lastUpdated}</p>
              
              <div className="mb-5">
                <p className="lead mb-4">
                  At {companyName}, we are committed to providing high-quality video-on-demand services. Please review our cancellation and refund policy before making a purchase or subscription.
                </p>
              </div>

              <div className="mb-5">
                <h2 className="text-primary mb-4 border-bottom pb-2">Cancellation Policy</h2>
                
                <div className="mb-4">
                  <h4 className="text-secondary mb-3">1. Subscription Cancellation</h4>
                  <div className="bg-light p-4 rounded">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3">
                        <i className="fas fa-user-cog text-primary me-2"></i>
                        You may cancel your subscription anytime through your account settings or by contacting us at 
                        <a href={`mailto:${email}`} className="text-primary"> {email}</a>
                      </li>
                      <li className="mb-3">
                        <i className="fas fa-calendar-alt text-primary me-2"></i>
                        Cancellations take effect at the end of the current billing cycle. You will retain access to your content until the subscription period ends.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="mb-4">
                  <h4 className="text-secondary mb-3">2. Single Purchase Cancellation</h4>
                  <div className="alert alert-info" role="alert">
                    <i className="fas fa-info-circle me-2"></i>
                    Once payment is processed for a one-time purchase (e.g., movie rentals or purchases), cancellations are not allowed.
                  </div>
                </div>

                <div className="mb-4">
                  <h4 className="text-secondary mb-3">3. Cancellation by MASTISHORTS TECHNOLOGY PRIVATE LIMITED</h4>
                  <div className="bg-light p-4 rounded">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3">
                        <i className="fas fa-shield-alt text-warning me-2"></i>
                        We reserve the right to cancel subscriptions or purchases due to payment issues, suspected fraudulent activity, or violations of our Terms of Use.
                      </li>
                      <li className="mb-3">
                        <i className="fas fa-bell text-primary me-2"></i>
                        If we cancel a subscription or purchase, we will notify you, and applicable refunds will be processed.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mb-5">
                <h2 className="text-primary mb-4 border-bottom pb-2">Refund Policy</h2>
                
                <div className="mb-4">
                  <h4 className="text-secondary mb-3">1. Subscription Refunds</h4>
                  <div className="bg-light p-4 rounded">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3">
                        <i className="fas fa-times-circle text-danger me-2"></i>
                        Refunds are not provided for subscription payments already processed.
                      </li>
                      <li className="mb-3">
                        <i className="fas fa-tools text-primary me-2"></i>
                        Exceptions may be granted in cases of technical issues that prevent service access, at our discretion.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="mb-4">
                  <h4 className="text-secondary mb-3">2. Single Purchase Refunds</h4>
                  <p>Refunds for one-time purchases are provided only under the following conditions:</p>
                  <div className="bg-success bg-opacity-10 p-4 rounded border border-success">
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3">
                        <i className="fas fa-exclamation-triangle text-success me-2"></i>
                        The purchased content is unavailable or has technical issues preventing playback.
                      </li>
                      <li className="mb-3">
                        <i className="fas fa-clock text-success me-2"></i>
                        The issue is reported within 24 hours of the purchase.
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="mb-4">
                  <h4 className="text-secondary mb-3">3. Refund Process</h4>
                  <div className="bg-light p-4 rounded">
                    <div className="row">
                      <div className="col-md-6">
                        <h6 className="text-primary mb-3">How to Request:</h6>
                        <ul className="list-unstyled">
                          <li className="mb-2">
                            <i className="fas fa-envelope text-primary me-2"></i>
                            Email us at <a href={`mailto:${email}`} className="text-primary">{email}</a>
                          </li>
                          <li className="mb-2">
                            <i className="fas fa-phone text-primary me-2"></i>
                            Call us at <a href={phoneLink} className="text-primary">{phone}</a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <h6 className="text-primary mb-3">Processing Time:</h6>
                        <p className="mb-0">
                          <i className="fas fa-calendar-check text-success me-2"></i>
                          Approved refunds will be processed to the original payment method within 5-10 business days.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-5">
                <h2 className="text-primary mb-4 border-bottom pb-2">Technical Issues</h2>
                <div className="alert alert-warning" role="alert">
                  <i className="fas fa-wrench me-2"></i>
                  <strong>Technical Support:</strong> For any technical issues affecting your access to content or subscription services, please reach out to us immediately. We will work to resolve the problem or provide a refund if the issue cannot be fixed.
                </div>
              </div>

              <div className="mb-5 bg-primary text-white p-4 rounded">
                <h2 className="text-white mb-4">Contact Us</h2>
                <p className="mb-3">For questions or concerns about this policy, please contact us:</p>
                <div className="row">
                  <div className="col-md-6">
                    <p className="mb-2">
                      <i className="fas fa-envelope me-2"></i>
                      <strong>Email:</strong> <a href={`mailto:${email}`} className="text-white">{email}</a>
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p className="mb-2">
                      <i className="fas fa-phone me-2"></i>
                      <strong>Phone:</strong> <a href={phoneLink} className="text-white">{phone}</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <BackToTop />
    </>
  );
};

export default Refund;
